import { BestellpositionArtikelLoseWareView } from '../../../types';
import styles from './LoseWareList.module.scss';
import { useSelector } from 'react-redux';
import { selectIsDebitor, selectIsFarmleiter } from '../../../../store/Navigation.store';
import {
    BezeichnungEntry,
    MengeEntry,
    ModifikationsstatusEntry,
    PreisartEntry,
    SiloEntry,
    WerkeEntry,
    WunschterminEntry,
    ZulagenEntry,
} from '../PropertyEntries';
import { selectIsBestellungExisting } from '../../../../store/Global.selectors';

export type Props = Readonly<{
    bestellpositionen: BestellpositionArtikelLoseWareView[];
}>;

export const LoseWareListReadonly = ({ bestellpositionen }: Props): JSX.Element => {
    const isDebitor = useSelector(selectIsDebitor);
    const isFarmleiter = useSelector(selectIsFarmleiter);
    const isExisting = useSelector(selectIsBestellungExisting);

    return (
        <div>
            {bestellpositionen.map((bestellposition, index: number) => {
                return (
                    <div className={styles._artikelContainer} key={index}>
                        <BezeichnungEntry.List bestellposition={bestellposition} readonly />
                        {(isDebitor || isFarmleiter) && isExisting ? (
                            <div className={styles._modifikationsContainer}>
                                <ModifikationsstatusEntry.List
                                    nummer={bestellposition.nummer}
                                    positionsnummer={bestellposition.positionsnummer}
                                />
                            </div>
                        ) : null}
                        <ZulagenEntry.DisplayList bestellposition={bestellposition} />
                        <div className={styles._amountsContainer}>
                            <MengeEntry.List bestellposition={bestellposition} readonly />
                            <SiloEntry.List bestellposition={bestellposition} readonly />
                        </div>
                        {(isDebitor || isFarmleiter) && isExisting ? (
                            <WunschterminEntry.List bestellposition={bestellposition} readonly />
                        ) : null}
                        <WerkeEntry.List bestellposition={bestellposition} readonly />
                        {isDebitor || isFarmleiter ? <PreisartEntry.List bestellposition={bestellposition} readonly /> : null}
                    </div>
                );
            })}
        </div>
    );
};
